import { formatIsoDate } from "utils/date";
import formatDate from "utils/formatDate";

const useBPChartTooltip = (bpData) => {
  const getTooltipData = (label) => {
    let relativeDAll = bpData.diastolic.allData.filter((item) => {
      return formatDate(formatIsoDate(item.timestamp)) === formatDate(label);
    });

    let relativeSAll = bpData.systolic.allData.filter((item) => {
      return formatDate(formatIsoDate(item.timestamp)) === formatDate(label);
    });

    let relativeHRAll = bpData.hr.filter((item) => {
      return formatDate(formatIsoDate(item.timestamp)) === formatDate(label);
    });

    const mergedAll = relativeDAll.map((dItem) => {
      const match = relativeSAll.find((sitem) => {
        return dItem.timestamp === sitem.timestamp;
      });

      const matchHR = relativeHRAll.find((hritem) => {
        return dItem.timestamp === hritem.timestamp;
      });

      const obj = {
        dValue: dItem.value,
        sValue: match.value,
        timestamp: dItem.timestamp,
        hr: matchHR.value,
      };

      return obj;
    });

    const sortedData = mergedAll.sort(function (x, y) {
      return new Date(y.timestamp) - new Date(x.timestamp);
    });

    return sortedData;
  };
  return { getTooltipData };
};

export default useBPChartTooltip;
